export enum PrivacyLevelEnum {
    Everybody = 0,
    MyCompany = 1,
    Myself = 2
}